import { PF } from '@pages/NeuralNetworkLogs/data';
import { useNeuralNetworkLogs } from '@pages/NeuralNetworkLogs/hooks';
import { Filters, Table } from '@pages/NeuralNetworkLogs/ui';
import { LogModal } from '@pages/NeuralNetworkLogs/ui/LogModal';
import '@pages/NeuralNetworkLogs/styles/NeuralNetworkLogs.desktop.scss';

export const NeuralNetworkLogs = () => {
  const {
    isPageLoading,
    isFetching,
    onFilterChange,
    onSearch,
    pagination,
    neuralNetworkLogsData,
    onPaginate,
    onReset,
    columns,
    isLogModalOpen,
    currentLog,
    closeLog,
    unsavedFilters,
  } = useNeuralNetworkLogs();

  return (
    <div className={`${PF}_container`}>
      <Filters
        values={unsavedFilters}
        disabled={isPageLoading}
        onFilterChange={onFilterChange}
        onSearch={onSearch}
        onReset={onReset}
      />
      <Table
        columns={columns}
        data={neuralNetworkLogsData || []}
        isPageLoading={isPageLoading}
        isFetching={isFetching}
        pagination={pagination}
        onPaginate={onPaginate}
      />

      <LogModal open={isLogModalOpen} log={currentLog} onClose={closeLog} />
    </div>
  );
};
